<template>
  <d-confirm-modal
    :modal="modal"
    :title="
      $t('users.change-status.title', {
        status: item.isActive
          ? $t('defaults.text.inactive').toLowerCase()
          : $t('defaults.text.active').toLowerCase(),
      })
    "
    :text="
      $t('users.change-status.text', {
        status: item.isActive
          ? $t('defaults.text.inactive').toLowerCase()
          : $t('defaults.text.active').toLowerCase(),
      })
    "
    :submitButtonText="
      item.isActive
        ? $t('defaults.button.deactivate')
        : $t('defaults.button.activate')
    "
    :submitButtonColor="item.isActive ? 'error' : 'success'"
    :isSubmitting="isSubmitting"
    @submitModal="handleSubmitModal"
    @closeModal="handleCloseModal"
  ></d-confirm-modal>
</template>

<script>
import { changeUserStatus } from "@/services/user";

export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    item: Object,
  },
  data() {
    return {
      isSubmitting: false,
    };
  },
  methods: {
    async handleSubmitModal() {
      try {
        this.isSubmitting = true;
        await changeUserStatus({
          id: this.item.id,
          isActive: !this.item.isActive,
        });
        this.$eventBus.$emit("notification", {
          type: "success",
          message: this.$t("users.change-status.alert.changed", {
            status: this.item.isActive
              ? this.$t("defaults.text.inactive").toLowerCase()
              : this.$t("defaults.text.active").toLowerCase(),
          }),
        });
        this.$emit("submitModal");
        this.handleCloseModal();
      } catch {
        this.$eventBus.$emit("notification", {
          type: "error",
          message: this.$t("defaults.text.request-error"),
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    handleCloseModal() {
      this.$emit("closeModal");
    },
  },
};
</script>
